import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { CandidatesPageComponent } from './candidates-page.component';
import { CandidateJobMatchesComponent } from './candidate-job-matches/candidate-job-matches.component';
import { FormsModule } from '@angular/forms';
import { TooltipModule, TabsModule, PaginationModule } from 'ngx-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { InfoIconModule } from 'src/app/shared/info-icon/info-icon.module';
import { CandidateCardIconsModule } from 'src/app/shared/candidate-card-icons/candidate-card-icons.module';
import { DataTablesModule } from 'angular-datatables';
import { JobProfileModule } from '../job-profile-page/job-profile/job-profile.module';
import { CandidateJobMatchProfileModule } from 'src/app/shared/candidate-job-match-profile/candidate-job-match-profile.module';
import { CandidatePossibleJobMatchesComponent } from './candidate-possible-job-matches/candidate-possible-job-matches.component';
import { CandidateFileUploadComponent } from './candidate-file-upload/candidate-file-upload.component';
import { CandidateFileUploadModule } from './candidate-file-upload/candidate-file-upload.module';
import { UploadFilesModule } from 'src/app/shared/upload-files/upload-files.module';
import { SendCandidateOutreachEmailModule } from 'src/app/shared/send-candidate-outreach-email/send-candidate-outreach-email.module';
import { CandidateCardModule } from './candidate-card/candidate-card.module';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.candidates',
    url: '/candidates',
    component: CandidatesPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      candidateStatuses: null,
      recruiters: null,
      visibilityFilters: null,
      searchString: null,
      candidateType: null
    }
  }
];

@NgModule({
  declarations: [CandidatesPageComponent, CandidateJobMatchesComponent, CandidatePossibleJobMatchesComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    InfiniteScrollModule,
    NgSelectModule,
    PipesModule,
    InfoIconModule,
    CandidateCardIconsModule,
    PipesModule,
    DataTablesModule,
    JobProfileModule,
    UploadFilesModule,
    SendCandidateOutreachEmailModule,
    CandidateCardModule,
    SkeletonLoaderModule,
    CandidateFileUploadModule,
    CandidateJobMatchProfileModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [CandidatesPageComponent, CandidateJobMatchesComponent, CandidatePossibleJobMatchesComponent, CandidateFileUploadComponent],
  exports: [CandidatesPageComponent, CandidateJobMatchesComponent, CandidateJobMatchProfileModule, CandidatePossibleJobMatchesComponent, CandidateFileUploadComponent]
})
export class CandidatesPageModule { }
